module.exports = __webpack_public_path__ + "img/2.61b4dd1b.png";